<div id="sh-change-organization-dialog-container-div" *transloco="let t; read: 'cloud.shared.switch-org'">
	<ng-container>
		<prism-dialog id="sh-change-organization-content-div" confirm-button="" cancel-button="" visible="true">
			<div>
				<h1 slot="dialog-title" id="sh-change-organization-title-h1">{{ t('change-organization') }}</h1>
			</div>
			<div id="sh-change-organization-title-div">
				{{ t('select-organization-from-list') }}
			</div>
			<div id="sh-change-organization-search-container-div">
				<prism-search-bar
					id="sh-change-organization-search-bar"
					(valueInput)="applyFilter($event.detail)"
					(valueChange)="applyFilter($event.detail)"
				></prism-search-bar>
				<prism-button
					variant="bright"
					id="sh-change-organization-create-button-div"
					(click)="openCreateOrganization()"
				>
					{{ t('create-organization') }}
					<prism-icon icon="add" slot="icon-start" size="sm"></prism-icon>
				</prism-button>
			</div>
			@if (toggleLoader() === false) {
				@if (organizationsList && organizationsList.length > 0) {
					<prism-list class="sh-change-organization-organizations-list" id="sh-change-organization-list">
						<prism-list-item
							id="sh-change-organization-organization-item-{{ org.id }}"
							class="sh-change-organization-organization-item"
							*ngFor="let org of organizationsList"
							(click)="selectOrganization($event, org)"
							[class.sh-change-organization-selected]="
								selectedOrganization && selectedOrganization.id === org.id
							"
						>
							<div
								class="sh-change-organization-details-div"
								id="sh-change-organization-details-div-{{ org.id }}"
							>
								<div
									class="sh-change-organization-icon-container-div"
									id="sh-change-organization-icon-container-div-{{ org.id }}"
									[style.background-color]="org.profileColor"
								>
									<div
										class="sh-change-organization-org-icon-div"
										id="sh-change-organization-org-icon-div-{{ org.id }}"
									>
										{{ org.initials }}
									</div>
								</div>
								<div
									class="sh-change-organization-organization-name-div"
									id="sh-change-organization-organization-name-div-{{ org.id }}"
								>
									<div id="sh-change-organization-name-details-{{ org.id }}">
										<h4
											id="sh-change-organization-organization-name-h4-{{ org.id }}"
											class="sh-change-organization-organization-name-h4"
										>
											{{ org.name }}
											@if (defaultOrgId === org.id) {
												({{ t('current') }})
											}
										</h4>
										<p
											class="sh-change-organization-company-name-p"
											id="sh-change-organization-company-name-p-{{ org.id }}"
										>
											{{ org.companyName }}
										</p>
									</div>
									<div id="sh-change-organization-icon-content-{{ org.id }}">
										@if (org.verificationStatus === verificationStatus.VERIFIED) {
											<prism-icon
												icon="verified"
												id="sh-create-organization-verify-icon-{{ org.id }}"
												size="md"
												class="sh-create-organization-verify-icon"
											></prism-icon>
										}
									</div>
								</div>
							</div>
						</prism-list-item>
					</prism-list>
				} @else {
					<div class="sh-change-organization-organizations-list" id="sh-change-organization-no-rows-div">
						<p id="sh-change-organization-no-organizations-p">
							{{ t('no-organizations-found') }}
						</p>
						<p id="sh-change-organization-different-search-text-p">
							{{ t('try-different-search') }}
						</p>
					</div>
				}
			}
			@if (toggleLoader()) {
				<div id="sh-change-organization-loader-div">
					<sh-loader></sh-loader>
				</div>
			}
			<div id="sh-change-organization-action-buttons-div">
				<prism-button variant="standard" id="sh-change-organization-cancel-button" (click)="closeDialog()">
					{{ 'cloud.shared.button-text.cancel' | transloco }}
				</prism-button>
				<prism-button
					[disabled]="!selectedOrganization || !selectedOrganization.id"
					variant="standard"
					id="sh-change-organization-create-org-button"
					(click)="changeOrganization()"
				>
					{{ t('change-organization') }}
				</prism-button>
			</div>
		</prism-dialog>
	</ng-container>
</div>
